"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalPlaformIds = exports.ExternalPlatformLinks = exports.ExternalPlatformLabels = void 0;
const common_1 = require("../../../../common");
exports.ExternalPlatformLabels = {
    baremetal: 'No platform integration',
    none: 'No platform integration',
    nutanix: 'Nutanix',
    external: 'Oracle Cloud Infrastructure (Requires a custom manifest)',
    vsphere: 'vSphere',
};
exports.ExternalPlatformLinks = {
    nutanix: common_1.NUTANIX_CONFIG_LINK,
    vsphere: common_1.VSPHERE_CONFIG_LINK,
    external: common_1.OCI_CONFIG_LINK,
};
exports.ExternalPlaformIds = {
    baremetal: '',
    none: '',
    nutanix: 'NUTANIX_INTEGRATION',
    external: 'EXTERNAL_PLATFORM_OCI',
    vsphere: 'VSPHERE_INTEGRATION',
};
//# sourceMappingURL=constants.js.map